import $ from "jquery";

export default () => {

    function updateLabelFocusState($label, $input) {
        if ($input.val()) {
            $label.addClass("focus-in");
        } else {
            $label.removeClass("focus-in");
        }
    }

    $(function () {

        // INPUT e TEXTAREA
        $('.umbraco-forms-form .umbraco-forms-label').each(function () {
            const $label = $(this);
            const $container = $label.parent();

            if ($container.hasClass('fileupload')) return;

            const $input = $container.find("input, textarea");

            // focusin/out eventi dinamici
            $input.on("focusin", () => $label.addClass("focus-in"));
            $input.on("focusout", () => updateLabelFocusState($label, $input));

            // stato iniziale
            updateLabelFocusState($label, $input);
        });

        // SELECT
        $('.umbraco-forms-form .umbraco-forms-field.dropdown').each(function () {
            const $field = $(this);
            const $label = $field.find('label');
            const $select = $field.find('select');

            $select.on('focusin', () => $label.addClass("focus-in"));
            $select.on('focusout', () => updateLabelFocusState($label, $select));

            updateLabelFocusState($label, $select);
        });

        // DATE
        $('.umbraco-forms-form .umbraco-forms-field.date').each(function () {
            const $field = $(this);
            const $label = $field.find('label');
            const $input = $field.find('input');

            $input.on('focusin', () => $label.addClass("focus-in"));
            $input.on('focusout change', () => updateLabelFocusState($label, $input));

            updateLabelFocusState($label, $input);
        });

        // Messaggio *Campi obbligatori
        $('.umbraco-forms-form').find('.umbraco-forms-navigation').before(function () {
            const hasRequiredFields = $(this).closest('.umbraco-forms-form').find('[aria-required="true"]').length > 0;
            if (!hasRequiredFields) return '';

            const lang = document.documentElement.lang;
            const msg = lang === 'it' ? '*Campi obbligatori' : '*Pflichtfelder';
            return $('<div class="text-start text-[0.88rem] text-[#000] -mb-4">' + msg + '</div>');
        });

        // Nel mobile aggiungi msg sotto la textarea
        if(window.innerWidth < 768) {
            $('.umbraco-forms-form').find('.umbraco-forms-field').each(function () {
                const $field = $(this);
                console.log($field);
                const $textarea = $field.find('textarea');
                if (!$textarea.length) return;
                    const lang = document.documentElement.lang;
                    const msg = lang === 'it' ? '*Campi obbligatori' : '*Pflichtfelder';
                    
                    // Aggiungi il messaggio dopo la textarea
                    $textarea.after($('<div class="text-end text-[0.88rem] text-[#000] mt-2">' + msg + '</div>'));
                
            });
        }

        // File upload personalizzato
        $('.custom-file-upload-input').each(function () {
            const $input = $(this);
            const inputId = $input.attr('id');
            const $container = $input.closest('div');
            const $label = $container.find('label[for="' + inputId + '"]');
            const $fileName = $container.find('.file-name');

            if (!$label.length || !$fileName.length) return;

            $input.on('change', function () {
                const fileNames = Array.from(this.files).map(file => file.name).join(', ');
                $fileName.text(fileNames || 'Nessun file selezionato');
            });

            $label.on('keypress', function (e) {
                if (e.key === 'Enter' || e.key === ' ' || e.which === 13 || e.which === 32) {
                    $input.trigger('click');
                    e.preventDefault();
                }
            });
        });

        // const allFields = $(".umbraco-forms-field").toArray();
        // const rows = [];

        // $.each(allFields, function(_, field) {
        //     const top = $(field)[0].getBoundingClientRect().top;
        //     const existingRow = rows.find(r => Math.abs(r.top - top) < 5); // tolleranza per differenze minime

        //     if (existingRow) {
        //     existingRow.fields.push(field);
        //     } else {
        //     rows.push({ top, fields: [field] });
        //     }
        // });

        //  let tabIndex = 1;
        // $.each(rows, function(_, row) {
        //     row.fields.sort(function(a, b) {
        //     return $(a)[0].getBoundingClientRect().left - $(b)[0].getBoundingClientRect().left;
        //     });
            
        //     $.each(row.fields, function(_, field) {
        //     $(field).find("input:not([type='hidden']), select, textarea").each(function() {
        //         $(this).attr("tabIndex", tabIndex++);
        //     });
        //     });
        // });

        // // Trova i bottoni di navigazione e assegna tabindex dopo tutti i campi
        // $('button[name="__prev"], button[name="__next"]').each(function() {
        //     $(this).attr("tabIndex", tabIndex++);
        // });
    });
};
